export class TextProcessor
{
    /**
     * Truncate a string if it is longer than the specified number of characters
     *
     * @param text String to truncate
     * @param length character limit
     * @param ending ending
     */
    public static truncateText(text: string, length = 100, ending = '...'): string
    {
        if (text && text.length > length)
        {
            text = text.substring(0, length - ending.length);
            text = text.substring(0, Math.min(text.length, text.lastIndexOf(' ')));
            return `${text} ${ending}`;
        }
        else
        {
            return text;
        }
    }

    public static validateKey(e: KeyboardEvent): void
    {
        const charKey = e && e.key.charCodeAt(0);
        if (e && ((charKey > 64 && charKey < 91) || (charKey > 96 && charKey < 123) || charKey === 8 || charKey === 32 || charKey === 189 ||
            charKey === 225 || charKey === 233 || charKey === 237 || charKey === 243 || charKey === 250 || charKey === 193 ||
            charKey === 201 || charKey === 205 || charKey === 211 || charKey === 218 || charKey === 241 || charKey === 209 ||
            ((charKey >= 48 && charKey <= 57) && e.key !== 'Shift')))
        {
            return;
        }
        else
        {
            e.preventDefault();
        }
    }

    public static validateKeyWithUnderscoreAndDashNoSpaces(e: KeyboardEvent): void
    {
        if (e.key === undefined)
        {
            return;
        }
        const charKey = e && e.key.charCodeAt(0);
        if (e && ((charKey > 64 && charKey < 91) || (charKey > 96 && charKey < 123) || charKey === 8 || charKey === 189 ||
            charKey === 225 || charKey === 233 || charKey === 237 || charKey === 243 || charKey === 250 || charKey === 193 ||
            charKey === 201 || charKey === 205 || charKey === 211 || charKey === 218 || charKey === 241 || charKey === 209 ||
            charKey === 45 || charKey === 95 || ((charKey >= 48 && charKey <= 57) && e.key !== 'Shift')))
        {
            return;
        }
        else
        {
            e.preventDefault();
        }
    }
}
